import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('sw-cms-preview-block-moorl-column-layout-nb-1-1', {
    template,
});
